import SliderQuestion from './SliderQuestion/SliderQuestion'
import FaceQuestion from './FaceQuestion/FaceQuestion'
import StarQuestion from './StarQuestion/StarQuestion'
import TextQuestion from './TextQuestion/TextQuestion'
import RadioQuestion from './RadioQuestion/RadioQuestion'
import MultipleChoiceQuestion from './MultipleChoiceQuestion/MultipleChoiceQuestion'

const Question = ({ question, type, options, optional, value, onChange }) => {
  if (type === 'slider') {
    return <SliderQuestion question={question} options={options} optional={optional} value={value} onChange={onChange} />
  }
  if (type === 'face') {
    return <FaceQuestion question={question} optional={optional} value={value} onChange={onChange} />
  }
  if (type === 'star') {
    return <StarQuestion question={question} optional={optional} value={value} onChange={onChange} />
  }
  if (type === 'radio') {
    return <RadioQuestion question={question} options={options} optional={optional} value={value} onChange={onChange} />
  }
  if (type === 'multiple_choice') {
    return <MultipleChoiceQuestion question={question} options={options} optional={optional} value={value} onChange={onChange} />
  }
  if (type === 'text') {
    return <TextQuestion question={question} optional={optional} value={value} onChange={onChange} />
  }
  return null
}

export default Question